module.exports = __webpack_public_path__ + "assets/-_14.a72ae4d2.svg";